import { WidgetType } from '../base/widget/WidgetTypes'

export const WidgetCrewtarget = {
  type: WidgetType.crewtarget,
  noPadding: true,
  title: 'Takt. Stärke',
  minSize: 4,
  defaultSize: 8,
  icon: 'AlarmLightOutline'
},

export default WidgetCrewtarget
